import React, {useEffect, useState} from 'react'
import {  useParams } from 'react-router-dom';
import { PageSixty, PageTitle } from 'monica-alexandria'
import { getReport } from '../../services/api/AutomatedReport';
import Report_Data from '../../sources/meta/pages/creator/components/report/Report_Data';
import { format_date } from '../../helpers/DateFormatter';

export default function REPORT() {
    const [reportId, setReportId] = useState(useParams().id);
    const [report, setReport] = useState();
    const [hidePage, setHidePage] = useState(false);


    useEffect(() => {
        getReport(reportId)
        .then((res) => {
            if(res.data.code === 200) {
                const fetchedReport = res?.data?.data?.report;
                console.log(fetchedReport);
                setReport(fetchedReport);
            }
            else {
                setHidePage(true);
            }
        })
        .catch(err => {
            console.error(err);
        });
    }, []);


    return (
        <PageSixty>
            {hidePage ? null :
            <Report_Data 
                viewMode={true}
                dateFrom={format_date(report?.dateFrom, report?.dateFormat)}
                dateTo={format_date(report?.dateTo, report?.dateFormat)}
                title={report?.title}
                sections={report?.sections}
                currency={report?.currency}
                brand="Questad Ads update"
            /> 
            }
        </PageSixty>
    )
}
